<template>
  <div id="page-wrapper" :class="popupShown ? 'popup-shown' : ''">
    <transition name="userpopup">
      <div id="popup-wrapper" v-if="popupShown">
        <!--        <template v-if="popupType === 'user'">-->
        <!--          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">-->
        <!--            <i class="fal fa-times"></i>-->
        <!--          </button>-->
        <!--          <user-form v-if="popupShown" @closePopup="closePopup" :userObj="activeUser"></user-form>-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
          <i class="fal fa-times"></i>
        </button>
        <team-form ref="teamform" @saved="savedHandler" v-if="popupType='team'"
                   @closePopup="closePopup"
                   @reload="loadTeams"
                   :team="activeTeam"></team-form>
        <!--        </template>-->
      </div>
    </transition>
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix h-100">
            <div id="main" class="container-fluid h-100">
              <div class="row row-offcanvas row-offcanvas-left clearfix h-100">
                <main class="main-content col content-full-width h-100" id="content" role="main">
                  <section id="userlist-manager" class="section h-100">
                    <div class=" h-100">
                      <div class="row mb-15 h-100">
                        <div id="vitamins" class="col-md-12">
                          <div v-if="role==='hr'" class="col-card h-100">
                            <team-list ref="teamlist" @openTeam="openTeam"></team-list>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

  import Header from "../Header";
  import Nav from "../Nav";
  // import axios from "../../axios-auth";
  import store from "../../store/store";
  import Userform from "../Users/Userform";
  import Userrow from "../Users/Userrow";
  import Pager from "../Pager";
  import {eventPath} from "../../polyfills";
  import TeamList from "./TeamList";
  import TeamForm from "./TeamForm";


  export default {
    components: {
      teamList: TeamList,
      appHeader: Header,
      appNavbar: Nav,
      userForm: Userform,
      userRow: Userrow,
      pager: Pager,
      teamForm: TeamForm
    },
    created() {
      this.clickOutsidePopup();
      this.role = store.state.viewMode
      // this.getMyTeams();
      // this.getUsers();
    },
    computed: {
      offset() {
        return this.resultsPerpage * (this.activePage - 1)
      }
    },
    methods: {
      loadTeams(){
        // console.log('team page load teams')
        this.$refs.teamlist.getTeams()
      },
      openTeam(team) {
        // console.log('opening team', team);
        this.activeTeam = team;
        this.popupType = 'team';
        this.popupShown = true;

        // console.log('activeteam', this.activeTeam)
      },
      savedHandler() {
        // console.log('saved handler')
        this.$refs.teamlist.getTeams()
      },
      clickOutsidePopup() {
        document.querySelector("body").addEventListener("mouseup", (e) => {
          const el = this.$el.querySelector('#popup-wrapper');

          const path = eventPath(e);
          let exceptedElement = false;
          path.forEach(pathEl => {
            // console.log('element id', pathEl.id);
            if (pathEl.classList && (
              pathEl.classList.contains('flatpickr-calendar')
              || pathEl.id === 'popup-wrapper'
            )
            ) {
              // console.log('pathEl', pathEl)
              exceptedElement = true
            }
          });

          if (path.includes(el) || exceptedElement) {
            // console.log('clicked inside popup')
          } else {
            //todo find way to exclude click in v-select, disabled this meanwhile
            // this.closePopup()
          }
        });
      },
      setPage(pagenumber) {
        let offset = this.resultsPerpage * (pagenumber - 1);
        //   console.log('changing page',[pagenumber,offset])
        this.start = offset;
        this.activePage = pagenumber
        this.getUsers(this.filter);
      },

      closePopup(reload = false) {
        // if (reload) {
        //   this.getMyTeams()
        // }
        this.popupShown = false;
      },


    },
    data() {
      return {
        popupType: 'user',
        activeTeam: null,
        activePage: 1,
        resultCount: 0,
        resultsPerpage: 10,
        filter: null,
        role: null,
        start: 0,
        // limit: 10,
        users: [],
        popupShown: false,
        activeUser: null,
      }
    }
  }
</script>


<style>

  @keyframes slide-in {
    from {
      top: -200%;
    }
    to {
      top: 0;
    }
  }

  @keyframes slide-out {
    from {
      top: 0;
    }
    to {
      top: -200%;
    }
  }

  .userpopup-enter {

  }

  .userpopup-enter-active {
    animation: slide-in .5s ease-out forwards;
  }

  .userpopup-leave {

  }

  .userpopup-leave-active {
    animation: slide-out .5s ease-out forwards;
  }

</style>



// WEBPACK FOOTER //
// src/components/Teams/Teampage.vue